import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { IconButton, Switch } from "@mui/material";

import CoAppDataGridListCell from "../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../global/components/datagrid/CoAppDataGridSkeletonCell";

export const pluginColumns = ["actions", "name", "groups", "active", "platformName"];

export const getPluginManagementColumns = (
	loading,
	handlePluginStatusToggleChange,
	openResourceEditPage,
	handleOpenResourceHomePage,
	navigationItemReferences
) => [
	{
		field: "name",
		headerName: "Name",
		flex: 1,
		editable: false,
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "groups",
		headerName: "Groups",
		sortable: false,
		flex: 1,
		editable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridListCell items={params.value} resource="Groups" />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "active",
		headerName: "Status",
		sortable: true,
		flex: 1,
		editable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<Switch
						checked={Boolean(params.value)}
						onChange={() => handlePluginStatusToggleChange(params.row.id, params.value)}
						disabled={false}
					/>
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "platformName",
		headerName: "Platform",
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridNameCell item={{name: params.value}} />
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "actions",
		type: "actions",
		sortable: false,
		flex: .1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<IconButton
						onClick={
							!params.row.isCustomerManaged
								?
								() => openResourceEditPage(params, navigationItemReferences.pluginNavItemIndex, "Plugins")
								:
								() => handleOpenResourceHomePage(navigationItemReferences.pluginNavItemIndex, "Plugins", params)
						}
					>
						<KeyboardArrowRight />
					</IconButton>
				}
				isLoading={loading}
			/>
		)
	}
];